import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_ABORT_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import {
  API_POST_EMPLOYEES_IMPORTS_ABORT_BY_JOB_ID,
  KEY_POST_EMPLOYEES_IMPORTS_ABORT_BY_JOB_ID,
} from '../constants';
import { MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_ABORT } from '../mocks';

type RequestEmployeesImportsAbort = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_ABORT_PATH_KEY
>['request']['path'];

export type CallParamsPostImportsAbortByJobId = Omit<
  RequestEmployeesImportsAbort,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostImportsAbortByJobId = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_ABORT_PATH_KEY
>['response']['body'];

type CallErrorPostImportsAbortByJobId = GenericApiError;

type CallSelectorsPostImportsAbortByJobId = unknown;

/**
 * Call to abort a employees import (still in RUNNING status) by job ID.
 */
export const postEmployeesImportsAbortByJobIdCall = createGeneralCall<
  CallParamsPostImportsAbortByJobId,
  CallResponsePostImportsAbortByJobId,
  CallErrorPostImportsAbortByJobId,
  CallSelectorsPostImportsAbortByJobId
>({
  id: KEY_POST_EMPLOYEES_IMPORTS_ABORT_BY_JOB_ID,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_EMPLOYEES_IMPORTS_ABORT_BY_JOB_ID(
        org as unknown as string,
        payload.jobId || '',
      );
    },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED()
    ? (MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_ABORT as never)
    : (undefined as never),
});
